// extracted by mini-css-extract-plugin
module.exports = {"body":"body_aVkN9","glass_morphism":"glass_morphism_7BQSx"};